import type { ComponentProps, PropsWithChildren } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { backgroundColor as bg, justifyContent, position } from 'styled-system';
import type { PositionProps } from 'styled-system';

import { Flex } from 'common/components/Flex';
import type { FlexProps } from 'common/components/Flex';
import type { Color } from 'common/theme/colors/types';
import type { BannerProps } from '../../types';

interface MediaContainerProps extends Partial<BannerProps>, PropsWithChildren {
  ref?: React.Ref<HTMLDivElement>;
}

const Container = styled(Flex)<
  FlexProps & PositionProps & Pick<MediaContainerProps, 'isFullWidth'>
>`
  ${bg};
  ${justifyContent};
  ${position};
`;

const containerStyles: Partial<ComponentProps<typeof Container>> = {
  width: '100%',
  position: 'relative',
  alignItems: 'center',
};

const MediaContainer = ({ ref, children, backgroundColor, isFullWidth }: MediaContainerProps) => (
  <Container
    ref={ref}
    {...containerStyles}
    bg={(backgroundColor ?? 'white') as Color}
    isFullWidth={isFullWidth}
    {...(!isFullWidth ? { justifyContent: 'flex-end' } : {})}
  >
    {children}
  </Container>
);

MediaContainer.displayName = 'MediaContainer';

export default MediaContainer;
